<template>
  <div>
    <h1 class="header-tus text-center text-3xl font-bold py-5">{{ template.title }}</h1>
    <p class="text-center py-5">{{ template.pretext }}</p>
    <template v-bind:key="question.id" v-for="(question, index) in template.questions">
      <SurveyQuestion v-if="question.field_type=='score'" :title="question.title"
                      :question-more="question.question_more"
                      question-more-answer-placeholder="Podajte nam nekaj več informacij" @change="questionChanged"
                      :question-id="question.id" :initial-value="index === 0 ? initialAnswer : null"></SurveyQuestion>
      <SurveyQuestionOptions v-if="question.field_type=='options'" :title="question.title" @change="questionChanged"
                             :question-id="question.id" :options="question.field_options"
                             :initial-value="index === 0 ? initialAnswer : null"></SurveyQuestionOptions>
      <SurveyQuestionText v-if="question.field_type=='text'" :title="question.title" @change="questionChanged"
                          :question-id="question.id" :initial-value="index === 0 ? initialAnswer : null"></SurveyQuestionText>
      <SurveyQuestionMultiple v-if="question.field_type=='multiple'" :title="question.title" @change="questionChanged"
                              :question-id="question.id" :initial-value="index === 0 ? initialAnswer : null"
                              :options="question.field_options"></SurveyQuestionMultiple>
      <EmptySpace></EmptySpace>
    </template>
  </div>
</template>

<script>
import EmptySpace from '@/components/EmptySpace'
import SurveyQuestionOptions from '@/components/SurveyQuestionOptions'
import NPSService from '@/services/nps'
import SurveyQuestionText from '@/components/SurveyQuestionText.vue'
import SurveyQuestionMultiple from '@/components/SurveyQuestionMultiple.vue'
import SurveyQuestion from '@/components/SurveyQuestion.vue'

export default {
  name: 'StepQuestionsSiri',
  components: {
    SurveyQuestion,
    SurveyQuestionMultiple,
    SurveyQuestionText,
    SurveyQuestionOptions,
    EmptySpace
  },
  props: {
    flowId: {},
    nps: {}
  },
  data () {
    return {}
  },
  computed: {
    npsId () {
      return this.nps.type
    },
    template () {
      return this.nps.template
    },
    initialAnswer () {
      let parts = window.location.search.split('=')
      if (parts[0] == '?q') {
        return decodeURI(parts[1])
      }
      return null
    }
  },
  methods: {
    questionChanged (qId) {
      if (qId.questionId) {
        const npss = new NPSService()
        npss.store(this.npsId, this.flowId, qId.questionId, qId.score, qId.more, qId.option, qId.text)
      }
      this.$emit('update:finished', true)
    }
  }
}
</script>

<style scoped>

</style>
